<template>
  <dialog-form
    :value="value"
    @input="$emit('input', $event)"
    :title="$localize('DeleteArticleImport.title')"
    action="delete"
    @commit="save"
  >
    <p>{{$localize('DeleteArticleImport.description')}}</p>
    <p>{{$localize('form.description.actionIsPermanent')}}</p>
  </dialog-form>
</template>

<script>
import DialogForm from "@/shared/components/DialogForm";
import sendCommand from "@/services/sendCommand";
import { isGuid } from "@/services/validation"

export default {
  components: { DialogForm },
  props: {
    articleImportId: {
      required: false,
      validator: isGuid
    },
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      article: {},
    };
  },

  methods: {
    async save(callback) {
      const result = await sendCommand("DeleteArticleImport", {
        articleImportId: this.articleImportId
      });

      if (result.success) {
        this.$emit("saved");
      }
      callback({success: result.success})
    }
  }
};
</script>
